import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'dailyGift', en);
i18next.addResources('fr', 'dailyGift', fr);

declare global {
  interface RegisteredLocales {
    dailyGift: typeof en;
  }
}
